var $3bf3cb0ce48a8078$exports = {};
$3bf3cb0ce48a8078$exports = {
    "dismiss": `Descartar`
};


export {$3bf3cb0ce48a8078$exports as default};
//# sourceMappingURL=es-ES.mjs.map
